<template>
  <div id="drop-time-picker">
    <!--<el-button @click="toggleList" type="text">{{dropBox1.show ? "收起列表" : "历史列表"}}</el-button>-->
    <transition name="el-zoom-in-top">
      <div v-show="dropBox1.show">
        <div class="drop-container">
          <div class="drop-box day-list">
            <p class="th-header"> 日期</p>
            <div class="scrollbar" ref="scrollDay">
              <div v-for="day in dayList" :key="day.id" @click="selectDay(day.value)"
                   :class="{'label-selected':selected.day===day.value}" class="label">
                {{day.label}}
              </div>
              <div @click="selectDay('more')" class="label">
                            <span>
                                 更多
                            </span>
                <div ref="datePicker"
                     style=" position: absolute;z-index: -1;top:0">
                  <el-date-picker
                    v-model="selected.addDay"
                    type="date"
                    align="left"
                    placeholder="选择日期"
                    @change="addDayfn"
                  >
                  </el-date-picker>

                </div>

              </div>
              <div class="label">
              </div>
            </div>

          </div>
          <transition name="el-zoom-in-center">

            <div v-if="selected.day" class="drop-box hour-list">
              <p class="th-header"> 小时</p>
              <div class="scrollbar" ref="scrollHour">
                <div @click="selectHour(index)"
                     :class="{'label-selected':selected.hourIndex==index,'no-data-hour':!oneDayData[index]}"
                     :asdasd="oneDayData[index]&&!oneDayData[index].length"
                     v-for="(one,index) in 24"
                     :key="one.id" class="label hour-col">
                  {{index >=10 ?  index:( '0' + index) }}
                </div>
                <div class="label">
                </div>
              </div>
            </div>
          </transition>
          <div v-if="listData.length||loading" class="drop-box item-list">
            <loading v-if="loading"></loading>
            <div v-else class="scrollbar" ref="scrollItem">
              <table ref="floatTable" class="table">
                <thead>
                  <tr v-if="type==='ALLOCATE'">
                    <th>时间(分)</th>
                    <template v-for="(data,dataKey) in listData[0]" v-if="dataKey!=='time_stamp'">
                      <template v-for="(value,key) in data" >
                        <th :key="key">
                          {{key}}
                        </th>
                      </template>
                    </template>
                  </tr>
                  <tr v-else>
                    <th>时间(分)</th>
                    <th v-for="th in listData[0]&&listData[0].shaojie.concat(listData[0].cewen)" :key="th.id">
                      {{th.th.length > 3 ? th.th : (th.th + '车位')}}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="type==='ALLOCATE'">
                  <tr @click="selectItem($index)" v-for="(tr,$index) in listData"
                      :class="{selected:selected.itemIndex===$index}" :key="tr.id">
                    <td>{{moment(tr&&tr.time_stamp).format("mm")}}</td>
                    <template v-for="(data,dataKey) in listData[$index]" v-if="dataKey!=='time_stamp'">
                      <template v-for="(value,key) in data">
                        <td :key="key">
                          {{value}}
                        </td>
                      </template>
                    </template>
                  </tr>
                    <tr>
                    <td></td>
                  </tr>
                </tbody>
                <tbody v-else>

                <tr  @click="selectItem($index)" v-for="(tr,$index) in listData"
                    :class="{selected:selected.itemIndex===$index}" :key="tr.id">
                  <td>{{moment(tr&&tr.time_stamp).format("mm")}}</td>
                  <td v-for="td in tr&&tr.shaojie.concat(tr.cewen)" :key="td.id">
                    {{td.data}}
                  </td>
                </tr>
                <tr>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="item-list">
            <p style="margin: 50px auto;text-align: center;">暂无数据</p>
          </div>

        </div>
        <div v-if="control" class="button-group">
          <div v-on:mousedown="selectButtonDown('PRE')" @mouseup="selectButtonUp">
            <div class="player-button">
              <i class="iconfont icon-kuaitui"></i>
            </div>
          </div>
          <div v-on:mousedown="selectButtonDown('NEXT')" v-on:mouseup="selectButtonUp">
            <div class="player-button">
              <i class="iconfont icon-kuaijin"></i>
            </div>
          </div>

        </div>
      </div>
    </transition>

  </div>

</template>


<script>
import moment from "moment";
import loading from "../common/loading.vue";
import img_no_data from "../../assets/images/no_data.svg";

import $ from 'jquery'
import 'floatthead'

export default {
  name: "dropTimePicker",
  //
  props: {
    data: Array,
    title: String,
    loading: Boolean,
    index: [Number, String],
    show: Boolean,
    type: {
      type: String
    },
    control: {
      default: true
    }
  },
  components: {
    loading,
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.toggleList(true);
      } else {
        this.toggleList(false);
      }
    },
    data() {
      this.dealhisData();
    }
  },

  data() {
    return {
      moment,
      img_no_data,
      //列表显示数据
      listData: [],
      oneDayData: [],
      dropBox1: {
        show: false
      },
      dropBox2: {
        show: false
      },
      selected: {
        day: moment().format("YYYY-MM-DD"),
        hour: moment().format("HH:00"),
        hourIndex: moment().format("H") * 1,
        itemIndex: 14,
        addDay: ""
      },
      itemList: [],
      dayList: [
        { label: "今天", value: moment().format("YYYY-MM-DD") },
        {
          label: "昨天",
          value: moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD")
        },
        {
          label: "前天",
          value: moment()
            .subtract(2, "day")
            .format("YYYY-MM-DD")
        }
      ],
      // mouseDown所需定时事件
      intervalEvent: {
        selected: ""
      },
      chartsPlayer: {
        show: false
      }
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    //处理传入的当天历史实时数据
    dealhisData() {
      let data = this.data,
        hourItem,
        oneDayData = [];
      console.log("dealhisData", data, typeof data)
      data.forEach(v => {
        
        hourItem = moment(v.time_stamp).format("H");
        if (oneDayData[hourItem]) {
          oneDayData[hourItem].push(v);
        } else {
          oneDayData[hourItem] = [v];
        }
      });
      this.oneDayData = oneDayData;
      this.listData = oneDayData[oneDayData.length - 1];
      console.log("dealhisData v", this.listData[0])
      this.selectHour("default");
    },
    toggleList(type) {
      this.dropBox1.show = !this.dropBox1.show;
      this.dropBox2.show = false;
      if (type === false) {
        this.dropBox1.show = false;
        this.dropBox2.show = false;
      } else {
        this.$nextTick(() => {});
      }
    },

    // 选择某一天
    selectDay(day) {
      if (day === "more") {
        let input = this.$refs.datePicker.getElementsByTagName("input")[0];
        input.focus();
      } else {
        this.selected.day = day;
        this.$emit("selectDate", this.selected);
      }
    },
    selectHour(index) {
      let oneDayData = this.oneDayData,
        dataList = this.dataList;
      if (index === "default") {
        index = oneDayData.length > 0 ? oneDayData.length - 1 : 0;
      }
      this.selected.hour = (index < 10 ? "0" + index : index) + ":00";
      this.selected.hourIndex = index;
      if (oneDayData[index]) {
        this.listData = oneDayData[index];
        let itemindex = this.selected.itemIndex;
        this.selectItem(itemindex ? itemindex : 0);
      } else {
        this.listData = [];
      }
    },
    selectItem(index) {
      let listData = this.listData;
      if (listData.length) {
        if (index > listData.length - 1) {
          index = listData.length - 1;
        } else if (index < 0) {
          index = 0;
        }
        this.selected.itemIndex = index;
        this.$emit("selectItem", listData[index], listData, index);
        this.$nextTick(() => {
          this.initScoll();
        });
      }
    },
    selectButtonDown(type) {
      this.selectButton(type);
      this.intervalEvent.selected = setInterval(() => {
        this.selectButton(type);
      }, 300);
    },
    selectButton(type) {
      let hourIndex = this.selected.hourIndex,
        itemIndex = this.selected.itemIndex,
        oneDayData = this.oneDayData,
        dataLength = this.listData.length;
      if (type === "PRE") {
        if (itemIndex > 0) {
          itemIndex = itemIndex - 1;
        } else {
          if (hourIndex > 0) {
            hourIndex = hourIndex - 1;
            itemIndex =
              oneDayData[hourIndex] && oneDayData[hourIndex].length - 1;
            if (!oneDayData[hourIndex] && hourIndex == -1) {
              return false;
            }
          }
        }
      } else if ((type = "NEXT")) {
        if (itemIndex < dataLength - 1) {
          itemIndex = itemIndex + 1;
        } else {
          if (hourIndex < 23) {
            hourIndex = hourIndex + 1;
            itemIndex = 0;
            //当前时间比较 TODO 优化
            if (
              !oneDayData[hourIndex] &&
              moment().isSame(this.selected.day, "day")
            ) {
              return false;
            }
          }
        }
      }
      this.selected.itemIndex = itemIndex;
      this.selected.hourIndex = hourIndex;
      this.selectHour(hourIndex);
      this.initScoll();
    },
    selectButtonUp() {
      clearInterval(this.intervalEvent.selected);
    },
    //用户选择日期
    addDayfn() {
      let addDay = moment(this.selected.addDay).format("YYYY-MM-DD"),
        dayList = this.dayList;
      if (
        dayList[0].value === addDay ||
        dayList[1].value === addDay ||
        dayList[2].value === addDay
      ) {
      } else {
        if (this.dayList[3]) {
          this.dayList.splice(3, 1, {
            label: addDay,
            value: addDay
          });
        } else {
          this.dayList.push({
            label: addDay,
            value: addDay
          });
        }
      }
      this.selected.day = addDay;
      this.$emit("selectDate", this.selected);
    },
    // 初始化滚动条
    initScoll() {
      let itemIndex = this.selected.itemIndex;
      let hourIndex = this.selected.hourIndex;
      this.$refs.scrollHour.scrollTop = 36 * (hourIndex - 2);
      if (this.data[itemIndex]) {
        this.$refs.scrollItem.scrollTop = 36 * (itemIndex - 2);
      }

//      this.table = $(this.$refs.floatTable)
//      this.table.floatThead({
//        position: 'auto',
//        top: 26, 
//      });
      
    },

    destroyFT () {
      this.$refs.floatTable('destroy')
    },

    openPlayer() {
      this.chartsPlayer.show = true;
    },
    closePlayer() {
      this.chartsPlayer.show = false;
      console.log("close");
    }
  }
};
</script>

<style scoped>
#drop-time-picker {
  position: relative;
  z-index: 1;
}

.drop-container {
  display: flex;
  border: 1px solid #d1dbe5;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  margin-bottom: 15px;
}

.drop-box {
  box-sizing: border-box;
  /*margin: 5px 0;*/
  max-height: 260px;
  border-right: 1px solid #ccc;
  overflow: hidden;
}

.drop-box .label {
  max-width: 120px;
  font-size: 14px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #48576a;
  height: 36px;
  line-height: 36px;
  box-sizing: border-box;
  cursor: pointer;
  text-align: center;
}


.drop-box .label-selected {
  color: #fff;
  background-color: #5093e1;
}

.drop-box .no-data-hour {
  color: #ccc;
  cursor: not-allowed;
}

.drop-box .label:hover {
  background-color: #71baff;
}

.drop-box .no-data-hour:hover {
  background-color: #fff;
}

.drop-box .label-selected:hover {
  background-color: #1c8de0;
}

.scrollbar {
  overflow: scroll;
  position: relative;
  height: 260px;
}


.item-list {
  flex: 1;
}

.th-header {
  padding: 7px 8px;
  line-height: 1.42857143;
  border-bottom: 1px solid #ddd;
  vertical-align: middle;
  font-size: 14px;
  border-bottom: 2px solid #ddd;
  text-align: center;
  font-weight: bold;
}

.item-list th {
  font-size: 14px;
  line-height: 34px!important;
  padding: 0!important;
}

.item-list tbody tr {
  cursor: pointer;
}

.item-list td {
  font-size: 18px;
  border-top: none;
  line-height: 36px!important;
  padding: 0!important;
}

.selected td {
  color: #fff;
}

.button-group {
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-around;
}

.button-group .el-button {
  width: 100px;
  margin: 0 25px;
}

table thead {
  position: sticky;
  top: 0;
}

table tbody {
  overflow: auto;
  /* display: block; */
}

table thead, tbody tr {
  /* display:table; */
  width:100%;
  table-layout:fixed;
  background-color: #fff;
}

#drop-time-picker .el-date-editor {
  width: 65px!important;
}

.player-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #fff;
  background-color: #2378dc;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// dropTimePicker.vue?9b1af4c0